import { useEffect } from "react";

import { useFeatureFlag } from "hooks/FlagHooks";

export function UserWayWidget() {
  const { data: userwayEnabled } = useFeatureFlag("userway");

  // Add the user way script tag if userway is enabled
  useEffect(() => {
    if (userwayEnabled) {
      const script = document.createElement("script");
      script.src = "https://cdn.userway.org/widget.js";
      script.setAttribute("data-position", "3");
      script.setAttribute("data-account", "hmcS6hM4GC");

      document.body.appendChild(script);
    }
  }, [userwayEnabled]);

  return null;
}
